var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('label', [_vm._v("Minimum charges per docket")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Choose an option")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minimumchargetype),
      expression: "minimumchargetype "
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "BasicFreight"
    },
    domProps: {
      "checked": _vm._q(_vm.minimumchargetype, "BasicFreight")
    },
    on: {
      "click": _vm.onMinimumchargetypeChange,
      "__c": function($event) {
        _vm.minimumchargetype = "BasicFreight"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("On basic freight")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minimumchargetype),
      expression: "minimumchargetype "
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "NetCharges"
    },
    domProps: {
      "checked": _vm._q(_vm.minimumchargetype, "NetCharges")
    },
    on: {
      "click": _vm.onMinimumchargetypeChange,
      "__c": function($event) {
        _vm.minimumchargetype = "NetCharges"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("On net charges (before GST)")])])])])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.labelofA))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 0px 0px"
    }
  }, [_c('label', [_vm._v("B = Minimum docket amount (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.minimumcharges),
      expression: "minimumcharges"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Minimum Charges",
      "id": "minimumcharges",
      "placeholder": "Min Docket Amount"
    },
    domProps: {
      "value": (_vm.minimumcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minimumcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Minimum Charges')),
      expression: "errors.has('Minimum Charges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Minimum docket amount is required")])], 1)]), _vm._v(" "), _c('label', [_vm._v("Minimum charges = Max (A,B)")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveMinimumCharges('save')
      }
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v("  \n  "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveMinimumCharges('saveAndNext')
      }
    }
  }, [_vm._v("Save and Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), _c('br')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-211f5551","hasScoped":true}!./src/modules/masterdata/views/ratetemplate/createratetemplate/minimumcharges/minimumcharges.component.html
// module id = 657
// module chunks = 3